import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;
const resolveSrc = (src) => (src?.startsWith("http") ? src : `${BACKEND}${src}`);

export const PhotoRibbon = () => {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((r) => {
        const all = [...(r.data.trips || []), ...(r.data.activities || []), ...(r.data["life-skills"] || [])];
        const picked = all.filter((_, i) => i % 2 === 0).slice(0, 14);
        setPhotos(picked);
      })
      .catch(() => {});
  }, []);

  if (photos.length < 6) return null;

  const strip = [...photos, ...photos];

  return (
    <div className="overflow-hidden bg-stone-900 py-8" aria-hidden="true" data-testid="photo-ribbon">
      <div className="ribbon-track flex gap-4 w-max">
        {strip.map((p, i) => (
          <img
            key={i}
            src={resolveSrc(p.src)}
            alt=""
            loading="lazy"
            className="h-36 sm:h-44 w-auto rounded-2xl object-cover shadow-lg"
          />
        ))}
      </div>
    </div>
  );
};
